<template>
  <MusicCollectionDetail v-if="this.globalResources.portalType === this.portalType.Music" :collection="collection" />
  <GameCollectionDetailBlueTheme v-else-if="portalGeneralInfo.Skin === 'cloob' ||
  portalGeneralInfo.Skin === 'jabe'" :collection="collection" />
  <GameCollectionDetail v-else-if="this.globalResources.portalType === this.portalType.Game &&
  portalGeneralInfo.Skin !== 'cloob' && portalGeneralInfo.Skin !== 'jabe'" :collection="collection" />
</template>

<script>
import enums from '@/utilities/enums.js'
import GameCollectionDetail from '@/components/GameCollectionDetail.vue'
import GameCollectionDetailBlueTheme from '@/components/GameCollectionDetailBlueTheme.vue'
import MusicCollectionDetail from '@/components/MusicCollectionDetail.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CollectionDetail',
  components: {
    GameCollectionDetail,
    MusicCollectionDetail,
    GameCollectionDetailBlueTheme
  },
  mixins: [enums],
  props: {
    collection: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      portalConfigurations: 'tenantDesign/config',
    }),
    portalGeneralInfo () {
      return this.portalConfigurations.general
    }
  }
}
</script>
